import { TooltipModule } from './../../../tooltip/tooltip.module';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonApplicationFlowModule} from '../../../commons-application-flow/common-application-flow.module';
import {
    MatButtonModule, MatButtonToggleModule, MatCheckboxModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule, MatSlideToggleModule
} from '@angular/material';
import {InvestmentApplicationPanVerificationComponent} from '../../../pan-verification/pan-verification.component';
import {ButtonModule} from '../../common/button/button.module';
import {InvestmentPreferencesComponent} from './steps/investment-preferences/investment-preferences.component';
import {KnowMoreAboutMasterPreferredRatingsComponent} from '../../../preferences/know-more-about-master-preferred-ratings/know-more-about-master-preferred-ratings.component';
import {PreferencesModule} from '../../../preferences/preferences.module';
import {RatingSelectorModule} from '../../../portfolio-creation/rating-selector/rating-selector.module';
import {RouterModule} from '@angular/router';
import { ConsentDialogComponent } from './steps/investment-preferences/consent-dialog/consent-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';

@NgModule({
    declarations: [InvestmentApplicationPanVerificationComponent, InvestmentPreferencesComponent, ConsentDialogComponent],
    imports: [
        CommonApplicationFlowModule, 
        MatFormFieldModule, 
        MatInputModule, 
        FormsModule, 
        ReactiveFormsModule, 
        CommonModule,
        MatProgressSpinnerModule, 
        MatButtonModule, 
        ButtonModule, 
        MatCheckboxModule, 
        MatExpansionModule,
        PreferencesModule,
        RatingSelectorModule,
        RouterModule,
        MatSlideToggleModule,
        MatButtonToggleModule,
        TooltipModule,
        MatDialogModule,
        MatIconModule
    ],
    entryComponents: [KnowMoreAboutMasterPreferredRatingsComponent]
})
export class InvestmentApplicationFlowModule {
}
